/**
 * 401（セッション切れ）を **1箇所で**扱うための橋渡し。
 *
 * 401 を検知するのは `fetcher.tsx` という React の外のモジュールだが、実際の後始末
 * （state・localStorage・SWR キャッシュのクリア）は AuthProvider が持つ。
 * そのため、AuthProvider が起動時にハンドラを登録し、検知側はここを経由して呼ぶ。
 *
 * かつては AuthContext が `window.fetch` を差し替えて全 fetch の 401 を拾っていたが、
 * 自 API 以外（外部 API や Sentry の送信）の 401 まで巻き込む・他ライブラリの
 * 計装と差し替え順序で競合する、という問題があったため、この形に置き換えた。
 */
type UnauthorizedHandler = () => void

let handler: UnauthorizedHandler | null = null

/** AuthProvider から呼ぶ。アンマウント時は null を渡して解除する。 */
export const setUnauthorizedHandler = (fn: UnauthorizedHandler | null): void => {
  handler = fn
}

/** 認証付きリクエストが 401 を返したときに呼ぶ。未登録なら何もしない。 */
export const notifyUnauthorized = (): void => {
  handler?.()
}
